import { SET_SHOW_NOTIFICATION } from '../reducers/showNotification'

const set = (message) => ({ type: SET_SHOW_NOTIFICATION, ...message })

const showNotification = (show, error, message) => (dispatch) => dispatch(set({ show, error, message }))

export { showNotification }
